var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DBEDDB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.6525 32.9894V53.5423C55.6525 54.6302 55.1885 55.6082 54.4501 56.2847C53.8015 56.8801 52.9418 57.242 51.9971 57.242H21.4132C20.4686 57.242 19.6089 56.8801 18.9603 56.2847C18.2218 55.6082 17.7578 54.6301 17.7578 53.5423V32.9894H55.6525Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.8283 37.2565C25.8283 35.8042 25.9442 34.3789 26.1673 32.9894H17.7578V53.5423C17.7578 54.6302 18.2285 55.6082 18.9774 56.2847C19.6353 56.8801 20.5072 57.242 21.4653 57.242H34.8104C29.2993 52.3414 25.8283 45.2036 25.8283 37.2565Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.5155 56.2942C53.8715 56.8837 53.0178 57.2421 52.0797 57.2421H21.7092C20.7712 57.2421 19.9175 56.8837 19.2734 56.2942L36.8945 41.3263L54.5155 56.2942Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.2744 48.5263L19.2734 56.2928C19.919 56.8831 20.7746 57.2421 21.7148 57.2421H34.8103C31.8051 54.5417 29.8023 52.3537 28.2744 48.5263Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M55.6525 32.4749V33.4907L46.8871 39.2191L36.7052 45.8736L17.7578 33.4907V32.4749C17.7578 30.457 19.3941 28.821 21.4132 28.821H51.9971C54.0163 28.821 55.6525 30.457 55.6525 32.4749Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M55.0839 38.6737C59.3742 38.6737 62.8523 35.1957 62.8523 30.9053C62.8523 26.6149 59.3742 23.1369 55.0839 23.1369C50.7935 23.1369 47.3154 26.6149 47.3154 30.9053C47.3154 35.1957 50.7935 38.6737 55.0839 38.6737Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.9449 38.3779C25.9449 34.9802 26.6743 31.7479 27.9894 28.821H21.5039C19.435 28.821 17.7578 30.4506 17.7578 32.461V33.4722L25.9468 38.6736C25.9455 38.5752 25.9449 38.4766 25.9449 38.3779Z",
    fill: "#34A853"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5817 43.5398C39.9164 43.1569 40.5044 43.1126 40.8948 43.4409L54.9481 55.2564C55.3385 55.5847 55.3837 56.1613 55.0489 56.5442C54.7142 56.9271 54.1263 56.9714 53.7358 56.6431L39.6826 44.8276C39.2921 44.4993 39.2469 43.9228 39.5817 43.5398Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8333 43.5401C34.1604 43.9233 34.1163 44.5004 33.7348 44.8289L20.0178 56.6429C19.6363 56.9715 19.0619 56.9272 18.7348 56.544C18.4077 56.1607 18.4518 55.5837 18.8333 55.2551L32.5503 43.4411C32.9318 43.1125 33.5062 43.1568 33.8333 43.5401Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5582 29.8652C20.0508 29.8652 18.8283 31.0701 18.8283 32.5571V33.0679L36.8049 44.654L49.3118 36.5931C49.7343 36.3208 50.3008 36.4376 50.5772 36.8541C50.8535 37.2706 50.7349 37.829 50.3124 38.1013L37.3052 46.4847C37.0012 46.6806 36.6085 46.6806 36.3046 46.4847L17.4139 34.3094C17.1556 34.143 17 33.8594 17 33.5553V32.5571C17 30.0755 19.0405 28.0632 21.5582 28.0632H47.2483C47.7532 28.0632 48.1625 28.4666 48.1625 28.9642C48.1625 29.4618 47.7532 29.8652 47.2483 29.8652H21.5582Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9183 32.2316C18.4255 32.2316 18.8366 32.6417 18.8366 33.1475V53.4323C18.8366 54.9437 20.0646 56.1684 21.5789 56.1684H52.2106C53.7248 56.1684 54.9529 54.9437 54.9529 53.4323V39.2298C54.9529 38.724 55.364 38.314 55.8712 38.314C56.3783 38.314 56.7895 38.724 56.7895 39.2298V53.4323C56.7895 55.9547 54.7397 58 52.2106 58H21.5789C19.0497 58 17 55.9547 17 53.4323V33.1475C17 32.6417 17.4111 32.2316 17.9183 32.2316Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7793 52.5052C31.7793 51.982 32.1935 51.5578 32.7045 51.5578H41.0856C41.5966 51.5578 42.0109 51.982 42.0109 52.5052C42.0109 53.0284 41.5966 53.4526 41.0856 53.4526H32.7045C32.1935 53.4526 31.7793 53.0284 31.7793 52.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2734 23.865C51.4668 23.865 48.3819 27.0176 48.3819 30.9053C48.3819 34.7929 51.4668 37.9455 55.2734 37.9455C59.08 37.9455 62.1649 34.7929 62.1649 30.9053C62.1649 27.0176 59.08 23.865 55.2734 23.865ZM46.5576 30.9053C46.5576 25.9865 50.4604 22 55.2734 22C60.0865 22 63.9892 25.9865 63.9892 30.9053C63.9892 35.8241 60.0865 39.8105 55.2734 39.8105C50.4604 39.8105 46.5576 35.8241 46.5576 30.9053Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3789 28.5804C53.3789 28.0854 53.803 27.6842 54.3262 27.6842H55.4632C55.9864 27.6842 56.4105 28.0854 56.4105 28.5804V33.6091C56.4105 34.104 55.9864 34.5053 55.4632 34.5053C54.94 34.5053 54.5159 34.104 54.5159 33.6091V29.4766H54.3262C53.803 29.4766 53.3789 29.0753 53.3789 28.5804Z",
    fill: "white"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmail);
export default __webpack_public_path__ + "static/media/checkEmail.0efafe80513ffc09e093a19a56313f38.svg";
export { ForwardRef as ReactComponent };